import { render, staticRenderFns } from "./ItemPartidoCuota.vue?vue&type=template&id=ff080328&"
import script from "./ItemPartidoCuota.vue?vue&type=script&lang=js&"
export * from "./ItemPartidoCuota.vue?vue&type=script&lang=js&"
import style0 from "./ItemPartidoCuota.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports